import styled from 'styled-components';

export const TextButtonStyled = styled.button`
  height: 30px;
  /* padding: 0 30px; */
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  color: ${({ theme, color }) => (color ? color : theme.darkGray)};
  background: none;
  transition: transform 100ms ease-in, color 0.2s ease;
  cursor: pointer;
  font-size: 14px;
  border: none;
  padding: 0;
  margin: 0;
  text-align: ${(props) => props.$textAlign || 'left'};
  svg {
    path {
      fill: ${({ theme, color }) => (color ? color : theme.darkGray)};
    }
  }

  @media (max-width: 800px) {
    /* height: 40px; */
    font-size: 14px;
  }

  @media (max-width: 380px) {
    /* height: 30px; */
    font-size: 12px;
  }

  ${({ $underline }) =>
    $underline &&
    `
    text-decoration: underline;
  `}

  /* Beside another control rather than stacked in a menu: it takes the width
     of its own label instead of the full row, and drops a size so it reads
     as the quieter of the two. */
  ${({ $small }) =>
    $small &&
    `
    width: auto;
    height: auto;
    font-size: 13px;
    justify-content: center;
  `}

  :hover {
    color: ${({ theme }) => theme.primary};
    text-decoration: underline !important;
    svg {
      path {
        fill: ${({ theme }) => theme.primary};
      }
    }
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;
    :hover {
      color: ${({ theme }) => theme.darkGray};
      text-decoration: none !important;
      svg {
        path {
          fill: ${({ theme, color }) => (color ? color : theme.darkGray)};
        }
      }
    }
  }

  svg {
    vertical-align: middle;
    position: relative;
    top: -1px;
    path {
      transition: fill 100ms ease-in, color 0.2s ease;
    }
  }

  :active {
    transform: translateY(3px);
  }

  margin: ${(props) => props.m};
  margin-top: ${(props) => props.mt}px;
  margin-bottom: ${(props) => props.mb}px;
  margin-left: ${(props) => props.ml}px;
  margin-right: ${(props) => props.mr}px;
  max-width: ${(props) => props.maxWidth};

  @media (max-width: 800px) {
    margin: ${(props) => props.mSM};
    margin-top: ${(props) => props.mtSM}px;
    margin-bottom: ${(props) => props.mbSM}px;
    margin-left: ${(props) => props.mlSM}px;
    margin-right: ${(props) => props.mrSM}px;
    max-width: ${(props) => props.maxWidthSM};
  }
`;
